export const CONTRACTING_SOURCE_APPLICATION = 'DEALCENTRAL';
